export * from './DefaultPageTemplate/DefaultPageTemplate'
export * from './MobilePageTemplate/MobilePageTemplate'
